import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Item, Input, Button, Icon, Table, Select, DatePicker, Radio } from 'antd';
import { createShowEditAction, modifyUser,getList } from '../../actions/user';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
/**
 * 弹窗组件
 */
class Edit extends React.Component {
    constructor(props) {
        super(props);
    };
    // 提交编辑
    async modifyUser() {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    await this.props.modifyUser(fieldsValue);
                    await this.props.form.resetFields();
                    await this.props.getList({page:this.props.page,pageSize:this.props.pageSize});
                } catch (err) {
                    alert(err);
                }
            } else {
                console.log(err);
            }
        })
    };
    render() {
        const { editing, index, modifyUser, changeEditState,detail,getList } = this.props;
        const { getFieldDecorator, validateFields, resetFields } = this.props.form;

        return (
            <Modal
                title="编辑用户"
                visible={editing}
                okText="保存"
                onCancel={() => {
                    changeEditState(false);
                }
                }
                onOk={this.modifyUser.bind(this)}
                key={index}
                maskClosable={false}
            >
                <Form>
                <FormItem
                        {...formItemLayout}
                        label="userid"
                        style={{ 'display': 'none' }}
                    >
                        {getFieldDecorator('_id', {
                            rules: [{ required: true, message: '请填写用户id!' }],
                            initialValue: detail._id,
                        })(
                            <Input />
                            )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="新密码"
                    >
                        {getFieldDecorator('password', {
                            rules: [{ required: false,whitespace: true, pattern: /^(^(?![^A-Z]+$)(?![^a-z]+$)(?!\D+$))\w{8,100}$/, message: '请输入不少于8位大小写字母加数字的密码!' }],
                        })(
                            <Input placeholder="新密码"/>
                            )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="权限"
                    >
                        {getFieldDecorator('role', {
                            rules: [{ required: true, message: '请选择权限!' }],
                            initialValue: detail.role
                        })(
                            <RadioGroup>
                                <Radio value={0}>普通用户</Radio>
                                <Radio value={1}>管理员</Radio>
                            </RadioGroup>
                            )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
};

const mapStateToProps = state => ({
    editing: state.user.userpageState.editing,
    detail: state.user.userDetail,
});

const mapDispatchToProps = dispatch => ({
    changeEditState: editing => dispatch(createShowEditAction(editing)),// 显示隐藏弹窗
    modifyUser: value => dispatch(modifyUser(value)), // 新增用户
    getList: params => dispatch(getList(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./components/sub-sider/user-edit.js